module.exports = __webpack_public_path__ + "static/media/kredyt_3.91bafa59.png";